// React
import React from 'react';
// External
import { Form } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import SelectSearch from 'react-select-search';
import { BsChevronDown } from 'react-icons/bs';
// Styles
import './styles.scss';

/**
 * @param {Object} props.className - Class to be applied to the button
 * @param {Object} props.controlClassName - Class to be applied to the button
 * @param {Array} props.options - Options to be displayed in the selector
 * @param {Boolean} props.hideIcon - Hide default icon
 */
class Selector extends React.Component {
    constructor(props) {
        super(props);
        let initialValue = this.props.label ? this.props.label : '';
        let shouldChangeAutomatically = false;
        let optionSelected;
        let count

        if (this.props.value) {
            optionSelected = props.options.find((option) => option.value === this.props.value);
            if (optionSelected) {
                initialValue = optionSelected.name;
                shouldChangeAutomatically = true;
            }
        }
        this.state = {
            count: 0,
            label: initialValue,
            hasError: this.props.hasError ? this.props.hasError : ''
        };

        if (shouldChangeAutomatically) {
            this.props.onChange(this.props.value, optionSelected);
        }

        this.selectSearchRefs = React.createRef();
        this.bOpenOptions = false;
        this.bEnterPressed = false;
    }

    componentDidUpdate(prevProps) {
        if (this.props.type !== 'Package') {
            if (prevProps.value !== this.props.value || prevProps.hasError !== this.props.hasError) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ hasError: this.props.hasError });
                if (!this.state.label && this.props.value) {
                    const optionSelected = this.props.options.find((option) => option.value === this.props.value);
                    
                    if (optionSelected) {
                        this.setState({ label: optionSelected.name });
                    }
                }
            }
            
            // Updates the value initially set if the options change
            if (prevProps.value === this.props.value && prevProps.options !== this.props.options) {
                const optionSelected = this.props.options.find((option) => option.value === this.props.value);
                if (optionSelected) {
                    this.setState({ label: this.state.label });
                }
            } else if (prevProps.value && !this.props.value) {
                this.setState({ label: this.props.label ? this.props.label : '' });
            }  else {
                if (prevProps.value !== this.props.value) {
                    const optionSelected = this.props.options.find((option) => option.value === this.props.value);
                    if (optionSelected) {
                        this.setState({ label: optionSelected.name });
                    }
                }
            }
            
        } else {
            this.state.count  = this.state.count + 1
        }
        
    } 

    onChange(value, obj) {
        this.setState({ label: obj.name, hasError: false });
        this.props.onChange(value, obj);

        // If the enter key is pressed, set it back to false and then focus back to the dropdown
        if (this.bEnterPressed) {
            this.bEnterPressed = false;
            setTimeout(() => this.selectSearchRefs.current.querySelector('input').focus(), 50);
        }
    }

    defaultValue(value, obj) {
        this.setState({ label: obj.name, hasError: false });
        this.props.defaultValue(value, obj);
    }

    render() {
            return (
                <div className="selector">
                    <SelectSearch
                        ref={this.selectSearchRefs}
                        className={this.props.className}
                        options={this.props.options ? this.props.options : []}
                        onChange={(value, obj) => { this.onChange(value, obj); }}
                        defaultValue={(value, obj) => { this.defaultValue(value, obj); }}
                        renderValue={(valueProps) => (
                            <Form.Control
                                {...valueProps}
                                className={this.state.hasError ? 'is-invalid' : ''}
                                name={this.props.name}
                                value={this.state.label}
                                type="text"
                                style={{width: `${this.props.hideIcon && '100%'}`}}
                                placeholder={this.props.placeholder}
                                onMouseDownCapture={objEvent => {
                                    this.bOpenOptions = true;
                                }}
                                onFocusCapture={objEvent => {
                                    if (!this.bOpenOptions) {
                                        objEvent.stopPropagation();
                                    } else {
                                        this.bOpenOptions = false;
                                    }
                                }}
                                onKeyDownCapture={objEvent => {                                    
                                    if (objEvent.key === 'Tab') {
                                        try {
                                            // Get the currently highlighted option and use it as the selected value
                                            const value = objEvent.target.parentElement.parentElement.parentElement.querySelector('.is-highlighted').value;
                                            
                                            this.onChange(value, { name: value });
                                        } catch(objError) {
                                            console.log('Error in selecting product filter options: ', objError);
                                        }
                                    }

                                    // If the enter key is pressed, set the flag to true and then set the open options flag to false
                                    if (objEvent.key === 'Enter') {
                                        this.bOpenOptions = false;
                                        this.bEnterPressed = true;
                                    }

                                    // If the arrow up or down is pressed, open the options
                                    if (objEvent.key === 'ArrowUp' || objEvent.key === 'ArrowDown') {
                                        this.selectSearchRefs.current.querySelector('input').blur();

                                        this.bOpenOptions = true;            

                                        this.selectSearchRefs.current.querySelector('input').focus();
                                    }
                                }}
                            />
                        )}
                    />
                    { !this.props.hideIcon && <BsChevronDown /> }
                </div>
            );
    }
}

export default withRouter(Selector);
